<!--
Search component to select origin / destination.
Usage: <Search name="text" placeholder="placeholder" otherLocation="origin/destination"/>
@author crm4f
-->
<template>
  <div class="feebackContainer">
    <Logo />
    <div class="headerTxtContainer">
      <h1 id="headerTxt">Tell us what you thought!</h1>
    </div>

    <div class="iconsContainer mt-2">
      <input type="radio" name="choice" class="hidden" id="happy" v-model="status" value="happy" checked="checked">
      <label for="happy">
        <font-awesome-icon class="feedbackIcon" :style="{ 'color': (status == 'happy' ? 'green' : 'inherit') }" icon="fa-regular fa-face-grin-wide" />
      </label>
      <input type="radio" name="choice" class="hidden" id="neutral" v-model="status" value="neutral" checked="checked">
      <label for="neutral">
        <font-awesome-icon class="feedbackIcon" :style="{ 'color': (status == 'neutral' ? '#ffbf00' : 'inherit') }" icon="fa-regular fa-face-meh" />
      </label>
      <input type="radio" name="choice" class="hidden" id="sad" v-model="status" value="sad" checked="checked">
      <label for="sad">
        <font-awesome-icon class="feedbackIcon" :style="{ 'color': (status == 'sad' ? 'red' : 'inherit') }" icon="fa-regular fa-face-sad-cry" />
      </label>
    </div>
    
    <div class="pb-1 w-50 m-auto mt-2">
      <textarea class="form-control" rows="4" v-model="feedback" placeholder="Leave us some feedback..."></textarea>
    </div>

    <div class="centered mt-2">
      <button :disabled="feedback == '' || submitDisabled" class="btn btn-primary" id="subBtn" @click="submitToIvanti(); submitDisabled = true;" type="button">Submit</button>
    </div>  

    <div class="centered mt-2" @click="go('/')">
      <a class="btn btn-primary">Return to map</a>
    </div> 

  </div>
</template>
  
<script setup>
import Logo from '../components/Logo.vue'
import { onMounted, ref } from 'vue'
import axios from 'axios'
import { useNavUtils } from '@/composables/NavigationUtils.js'

const { go } = useNavUtils()
const status = ref('happy')
const feedback = ref('')
const submitDisabled = ref(false)

onMounted(() => {
  console.log('feedback mounted')
})

function submitToIvanti () {
  var data = { "status": status.value , "body": feedback.value }
	axios.post('map/ivanti/request', data)
  .then(() => {
    alert('thanks for the feedback!')
    go('/')
  })
}

</script>
  
<style scoped>

#headerTxt {
  font-weight: bold;
}

.feedbackIcon {
  font-size: 50px;
  cursor: pointer;
  margin-left: 5px;
  margin-right: 5px;
}

[type='radio'] {
  display: none; 
}

</style>